
import { component } from '@/helpers/vueTyped';
import FeedFetcher from '@/components/SharedViews/FeedFetcher.vue';
import CardRail from './CardRail.vue';
import { Summary } from '@/api/validators/content';
import { SummaryType } from '@/components/Sport/types';
import Rail from './Rail.vue';
import { repeat } from '@/components/SharedViews/Repeat.vue';
import ContentCardGhostLoader from '../Card/ContentCard/ContentCardGhostLoader.vue';
import ScoreCardGhostLoader from '../Card/ScoreCard/ScoreCardGhostLoader.vue';

interface CardRailContainerProps {
  feedType: 'article' | 'video' | 'score';
  optionalFeedArgs?: object;
  summaryType: SummaryType;
  categoryName: string;
  autoUpdateFeed?: boolean;
  autoUpdateSummary?: boolean;
  cacheSummary?: boolean;
  cardFocusCallback?: (summary: Summary) => void;
  firstCardLoadedCallback?: (summary: Summary) => void;
}

export default component<CardRailContainerProps>()({
  name: 'CardRailContainer',

  props: {
    feedType: {},
    optionalFeedArgs: {},
    summaryType: {},
    categoryName: {},
    autoUpdateFeed: Boolean,
    autoUpdateSummary: Boolean,
    cacheSummary: {
      type: Boolean,
      default: true,
    },
    cardFocusCallback: {
      type: Function,
      default: () => null,
    },
    firstCardLoadedCallback: {
      type: Function,
      default: () => null,
    },
  },

  methods: {
    focus() {
      if (this.$refs.loading) {
        (this.$refs.loading as HTMLElement).focus();
      } else if (this.$refs.rail) {
        (this.$refs.rail as InstanceType<typeof CardRail>).focus();
      } else {
        this.$spatialFocus.lastFocused?.focus();
      }
    },

    async focusNextTick() {
      await this.$nextTick();
      this.focus();
    },
  },

  render() {
    return (
      <FeedFetcher
        type={this.feedType}
        optionalFeedArgs={this.optionalFeedArgs}
        autoUpdate={this.autoUpdateFeed}
        scopedSlots={{
          default: ({ feed, fetchMore, isLoading }) => {
            if (feed.length === 0) {
              if (isLoading) {
                return (
                  <Rail categoryName={this.categoryName} class='rail-loading'>
                    {repeat(10, () => (
                      this.summaryType === 'articles' || this.summaryType === 'video'
                        ? <ContentCardGhostLoader />
                        : <ScoreCardGhostLoader />
                    ))}
                  </Rail>
                );
              }

              return null;
            }

            if (document.activeElement === this.$refs.loading) {
              this.focusNextTick();
            }

            return (
              <CardRail
                ref='rail'
                class={this.$vnode.data?.class}
                feed={feed}
                endReachedCallback={fetchMore}
                cardFocusCallback={this.cardFocusCallback!}
                firstCardLoadedCallback={this.firstCardLoadedCallback!}
                categoryName={this.categoryName}
                summaryType={this.summaryType}
                autoUpdate={this.autoUpdateSummary}
                cacheSummary={this.cacheSummary}
                on={this.$listeners}
              />
            );
          },
        }}
      />
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0642d691/CardRailContainer.vue" });